import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'
import Text from '../../../../../../components/pdf/Text'
import { getAverageByType, getProtectionDegreeAverage, getResultDataCharts } from '../../../_helpers/pdfHelpers'
import Separator from '../../../../../../components/pdf/Separator'
import BarChart from '../../../components/chats/BarChart'

const TableResults = ({ diagSegValues }) => {
  const valuesByType = getAverageByType(diagSegValues)
  const chartData = getResultDataCharts(valuesByType)

  const config = {
    data: chartData,
    height: 300,
    xField: 'label',
    yField: 'percentage',
    color: '#9999ff'
  }

  return (
    <>
      {!!chartData.length && <BarChart {...config} />}
      <Separator weight={10} />
      <Table color="transparent" width="70%">
        {chartData.map((item, index) => {
          const length = chartData.length
          const isLast = index === length - 1
          return (
            <>
              <TableRow color="transparent">
                <TableCol color="transparent" style={isLast && { borderTop: '1px solid #333' }}>
                  <Text semibold={!isLast} bold={isLast} size={11}>
                    {item.label}
                  </Text>
                </TableCol>
                <TableCol color="transparent" style={isLast && { borderTop: '1px solid #333' }}>
                  <Text semibold={!isLast} bold={isLast} size={11} align="center">
                    {item.percentage.toFixed(1)}%
                  </Text>
                </TableCol>
                <TableCol color="transparent" style={isLast && { borderTop: '1px solid #333' }}>
                  <Text semibold={!isLast} bold={isLast} size={11} align="center">
                    {item.grauVulnerabilidadePercentage.toFixed(1)}%
                  </Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
      </Table>
      <Separator weight={10} />
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor>
          <TableCol rowSpan={2} bgColor="#F2F2F2" useFontBaseColor width="70%">
            <Text bold align="center">
              ÁREAS AVALIADAS
            </Text>
          </TableCol>
          <TableCol colSpan={4} bgColor="#F2F2F2" useFontBaseColor>
            <Text bold align="center">
              MEDIDAS DE PROTEÇÃO
            </Text>
          </TableCol>
          <TableCol rowSpan={2} bgColor="#F2F2F2" useFontBaseColor>
            <Text bold size={9} align="center">
              GRAU DE PROTEÇÃO
            </Text>
          </TableCol>
          <TableCol rowSpan={2} bgColor="#F2F2F2" useFontBaseColor>
            <Text bold size={9} align="center">
              GRAU DE VULNERABILIDADE
            </Text>
          </TableCol>
        </TableRow>
        <TableRow bgColor="#F2F2F2" useFontBaseColor>
          <TableCol width="10%" useFontBaseColor>
            <Text size={9} bold align="center">
              ELETRÔNICA
            </Text>
          </TableCol>
          <TableCol width="10%" useFontBaseColor>
            <Text size={9} bold align="center">
              HUMANA
            </Text>
          </TableCol>
          <TableCol width="10%" useFontBaseColor>
            <Text size={9} bold align="center">
              FÍSICA
            </Text>
          </TableCol>
          <TableCol width="10%" useFontBaseColor>
            <Text size={9} bold align="center">
              ORGANIZATIVA
            </Text>
          </TableCol>
        </TableRow>
        {valuesByType.map(item => {
          if (item.type === 'sistemasGerais') return null

          const resultMPE = item?.medidasProtecaoEletronica?.result
          const resultMPH = item?.medidasProtecaoHumana?.result
          const resultMPF = item?.medidasProtecaoFisica?.result
          const resultMPO = item?.medidasProtecaoOrganizativa?.result
          const grauProtecao = item?.grauProtecao
          const grauVulnerabilidade = item?.grauVulnerabilidade

          return (
            <>
              <TableRow useFontBaseColor>
                <TableCol useFontBaseColor>
                  <Text>{item.title}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center">{resultMPE.toFixed(1)}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center">{resultMPH.toFixed(1)}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center">{resultMPF.toFixed(1)}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center">{resultMPO.toFixed(1)}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center" bold>
                    {grauProtecao.toFixed(1)}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center" bold>
                    {grauVulnerabilidade.toFixed(1)}
                  </Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
        <TableRow bgColor="#F2F2F2" useFontBaseColor>
          <TableCol></TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={9}>
              PREVENÇÃO E COMBATE A INCÊNDIOS
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={9}>
              ACESSIBILIDADE
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2}>
            <Text bold align="center" size={9}>
              MÉDIA
            </Text>
          </TableCol>
        </TableRow>
        {diagSegValues.map(item => {
          if (item.type !== 'sistemasGerais') return null

          const resulPCI = item?.prevencaoCombateIncendios?.result
          const resultA = item?.acessibilidade?.result
          const grauProtecao = item?.grauProtecao
          const grauVulnerabilidade = item?.grauVulnerabilidade

          return (
            <>
              <TableRow useFontBaseColor>
                <TableCol useFontBaseColor>
                  <Text>{item.title}</Text>
                </TableCol>
                <TableCol colSpan={2} useFontBaseColor>
                  <Text align="center">{resulPCI.toFixed(1)}</Text>
                </TableCol>
                <TableCol colSpan={2} useFontBaseColor>
                  <Text align="center">{resultA.toFixed(1)}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text bold align="center">
                    {grauProtecao.toFixed(1)}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text bold align="center">
                    {grauVulnerabilidade.toFixed(1)}
                  </Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}

        <TableRow bgColor="#000" useFontBaseColor>
          <TableCol colSpan={5} useFontBaseColor>
            <Text bold color="#FFF">
              MÉDIA FINAL DO EMPREENDIMENTO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold color="#FFF" align="center">
              {getProtectionDegreeAverage(diagSegValues).toFixed(1)}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold color="#FFF" align="center">
              {(99.8 - getProtectionDegreeAverage(diagSegValues)).toFixed(1)}
            </Text>
          </TableCol>
        </TableRow>
      </Table>
    </>
  )
}

export default TableResults
